import * as types from '../actionTypes/SYFActionTypes';
/**
 * Possible state
 * isLoading
 * isSuccess
 * error
 * getQSEligibleCalled
 * data - spreaded contains all /qs/offer response
 * isWigetLoaded - when view offer loads by syf
 * removePreshellLoader - success/failure of syf script load
 * hideBannerOnClose - when customer should be displaced banner again
 */
export default function SYFQuickScreenReducer(state = {}, action = {}) {
    switch (action.type) {
        case types.GET_QUICKSCREEN_ELIGIBLITY_CHECK: {
            const isLoading = true;
            const isSuccess = false;
            const error = null;
            const getQSEligibleCalled = true;
            return { ...state, isLoading, error, getQSEligibleCalled, isSuccess };
        }

        case types.GET_QUICKSCREEN_ELIGIBLITY_CHECK_SUCCESS: {
            const { data } = action.payload;
            return {
                ...state,
                isLoading: false,
                getQSEligibleCalledSuccess: true,
                ...data,
                isSuccess: true,
            };
        }

        case types.RESET_QUICKSCREEN_ELIGIBLITY: {
            return {};
        }

        case types.GET_QUICKSCREEN_ELIGIBLITY_CHECK_FAILURE: {
            const { error } = action.payload;
            return {
                ...state,
                error,
                isSuccess: true,
                getQSEligibleCalled: false,
                isLoading: false,
            };
        }

        case types.UPDATE_QUICKSCREEN_WIDGET_DETAILS_SUCCESS: {
            const { payload } = action;
            return { ...state, isLoading: false, ...payload, isSuccess: true };
        }

        case types.WEB_GET_REWARD_PROFILE_REQUEST_QS: {
            const { payload } = action;
            return { ...state, isLoading: true, isSuccess: false, error: null, ...payload };
        }

        case types.WEB_OPEN_QUICK_SCREEN_REQUEST: {
            const { payload } = action;
            return { ...state, isLoading: false, isSuccess: true, error: null, ...payload };
        }

        default:
            return state;
    }
}
